import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { Loading } from '../Loading/Loading'
import { ErrorConnection } from '../Error/Error'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const SelectList = ({ title, apiService, args, conditions, setConditions = null, handleChange, multiple, defaultSetterFunction, setNextListEnable = null, addSelectAllOption = false, removeElement = null }) => {
    let { data, isLoading, isError, error } = useQuery([title, args],
        async () => await apiService(args),
        {
            enabled: conditions
        }
    );

    useEffect(() => {
        if (data) {
            if(addSelectAllOption && !removeElement) {
                let selectAllOption = {
                    label: 'Seleccionar todos',
                    value: 0
                }
                data.data.list.unshift(selectAllOption)
            }
            if (!data.success)
                console.log("error");
            else {
                if (!multiple) {
                    let objDefault = data.data.list.filter(obj => obj.value === data.data.defaultId)[0];
                    if (objDefault === undefined) objDefault = data.data.list[0];
                    defaultSetterFunction((removeElement === '0') ? data.data.list.filter(item => item.value !== removeElement)[0] : objDefault);
                }
                else {
                    let resultFinal = [];
                    Array.isArray(data.data.defaultId) ? data.data.defaultId.forEach((value) => {
                        let result = (data.data.list.filter(obj => obj.value === value)[0]).value
                        resultFinal.push(result);
                    }) : resultFinal.push(data.data.defaultId);
                    defaultSetterFunction(resultFinal);
                }
                if (setNextListEnable) setNextListEnable(true);
                if (setConditions) setConditions(false);
            }
        }
    }, [data]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    // let id = `select-${title}`;
    let label = title ? title.charAt(0).toUpperCase() + title.slice(1) : "";

    const animatedComponents = makeAnimated();

    const getOptionValue = idDefault => {
        let resultFinal;
        if (!multiple) return data.data.list.filter(obj => obj.value === idDefault)
        else {
            resultFinal = [];
            Array.isArray(idDefault) ? idDefault.forEach((value) => {
                let result = data.data.list.filter(obj => obj.value === value)
                resultFinal.push(result[0]);
            }) : resultFinal.push(idDefault);
            return resultFinal;
        }
    }

    const selecthandleChange = (value) => {
    };


    return (
        <>
            {
                data &&
                (
                    <>
                        {label && <div className="fw-bold fs-7 text-gray-600 mb-1">{label}:</div>}
                        <Select
                            classNamePrefix='filter'
                            components={animatedComponents}
                            defaultValue={(removeElement === '0') ? [data.data.list.filter(item => item.value !== removeElement)[0]] : getOptionValue(data.data.defaultId)}
                            isMulti={multiple}
                            closeMenuOnSelect={!multiple}
                            options={(removeElement) ? data.data.list.filter(item => item.value !== removeElement) : data.data.list}
                            onChange={(handleChange)}
                        />
                    </>
                )
            }
        </>
    );
};

export default SelectList;